var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInit)?_c('div',{staticClass:"chart-container",style:(("width: " + _vm.width + "; height: " + _vm.height + ";"))},[_c('canvas',{ref:"chart",staticClass:"chart",style:(("max-height: " + _vm.height + ";"))})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }